import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import ChildSettingsForm from '../children/SettingsForm';
import ReduxBlockUi from 'react-block-ui/redux';
import {
	PARENT_FETCH_REQUEST, PARENT_FETCH_SUCCESS, PARENT_FETCH_FAILURE,
	CHILD_CREATE_REQUEST, CHILD_CREATE_FAILURE
} from '../actions';
import ChildrenList from '../children/List';
import FormComponents from '../assessmentForms/Components';
import AssessmentForm from '../assessmentForms/Form';
import {
	MEDICAL_INFORMATION_FETCH_REQUEST, MEDICAL_INFORMATION_FETCH_SUCCESS, MEDICAL_INFORMATION_FETCH_FAILURE,
	MEDICAL_INFORMATION_UPDATE_REQUEST, MEDICAL_INFORMATION_UPDATE_SUCCESS, MEDICAL_INFORMATION_UPDATE_FAILURE
} from '../children/actions';
import { SubmissionError } from 'redux-form';

class Child extends Component {

	constructor(props) {
		super(props);
		this.handleSameAsParentChange = this.handleSameAsParentChange.bind(this);
		this.state = { sameAsParent: false };
	}

	handleSameAsParentChange() {
		this.setState({ sameAsParent: !this.state.sameAsParent });
	}

	componentWillReceiveProps(nextProps) {
		if (this.props.mode !== 'select' && nextProps.mode === 'select' && nextProps.children.length === 1) {
			this.props.onSelectChild(nextProps.children[0].id);
		}
	}

	renderAddChild() {
		const { onAddChild, genderTypes, mode, requireChildLastName, requireChildSchool, enableParentSelfBooking, hasSameAsParentChild } = this.props;

		return <ReduxBlockUi block={CHILD_CREATE_REQUEST} unblock={CHILD_CREATE_FAILURE}>
			<ChildSettingsForm onSubmit={onAddChild} genderTypes={genderTypes} requireChildLastName={requireChildLastName}
				requireChildSchool={requireChildSchool}
				backPath={mode === 'add' ? '/children' : '/booking/child'} initialValues={{ sameAsParent: false }}
				enableParentSelfBooking={enableParentSelfBooking}
				sameAsParent={this.state.sameAsParent}
				sameAsParentChange={this.handleSameAsParentChange}
				hasSameAsParentChild={hasSameAsParentChild}
			/>
		</ReduxBlockUi>;
	}

	renderSelectChild() {
		const { children, onSelectChild, onSelectNewChild, t } = this.props;

		return (
			<div>
				<div className='steps_title'>{t('FO_Booking_Child_Message')}</div>
				<ReduxBlockUi block={PARENT_FETCH_REQUEST} unblock={[PARENT_FETCH_SUCCESS, PARENT_FETCH_FAILURE]}>
					<ChildrenList data={children} onSelect={onSelectChild} onSelectNew={onSelectNewChild} />
				</ReduxBlockUi>
			</div>
		);
	}

	handleMedicalInfoFormSubmit(values, requiredFields, validationFunc) {
		const { t, medicalInformation, onUpdateMedicalInformation, clearMedicalInfoFormErrors } = this.props;

		clearMedicalInfoFormErrors();

		let errors = {};
		if (requiredFields) {
			requiredFields.forEach(field => {
				if (values[field] == null || values[field] === '') {	// null, undefined or empty are invalid, 0 is a valid value
					errors[field] = t('Validator_Required');
				}
			});
		}

		if (validationFunc) {
			errors = Object.assign(errors, validationFunc(values, t));
		}

		// throw redux-form error if fields are missing when submiting form
		if (Object.keys(errors).length > 0) {
			//toast.error(t('FO_IndividualConsultationForm_ValidationErrors'));
			throw new SubmissionError(errors);
		}

		onUpdateMedicalInformation({ ...medicalInformation, content: values });
	}

	renderChildMedicalInformation() {
		const { selectedChild, medicalInformation, currentMedicalInfoFormValues, changeMedicalInfoFormValue, t } = this.props;
		const { component, requiredFields, validationFunc } = medicalInformation ?
			FormComponents(medicalInformation, { showResults: false }, currentMedicalInfoFormValues, changeMedicalInfoFormValue) :
			{ component: null, requiredFields: [], validationFunc: null };

		return <div>
			<div className='steps_title'>{t('FO_Booking_Child_MedicalInformation', { name: selectedChild && selectedChild.fullName })}</div>
			<ReduxBlockUi block={[MEDICAL_INFORMATION_FETCH_REQUEST, MEDICAL_INFORMATION_UPDATE_REQUEST]}
				unblock={[MEDICAL_INFORMATION_FETCH_SUCCESS, MEDICAL_INFORMATION_FETCH_FAILURE, MEDICAL_INFORMATION_UPDATE_SUCCESS, MEDICAL_INFORMATION_UPDATE_FAILURE]}>
				{medicalInformation && <AssessmentForm
					title='' description=''
					formComponent={component}
					backPath='child?reset=true'	// path relative to /booking or /workshop booking
					enableFinal={false} showFormActionsOnTop={false}
					saveDraftButtonText={t('Common_Save')} saveDraftButtonIcon={<React.Fragment />}
					onSubmit={(values, isFinal) => this.handleMedicalInfoFormSubmit(values, requiredFields, validationFunc)}
					initialValues={medicalInformation.content}
					isReadonly={false}
				/>}
			</ReduxBlockUi>
		</div>;
	}

	render() {
		const { mode, selectedChild } = this.props;

		switch (mode) {
			case 'add':
				return this.renderAddChild();
			case 'medicalInfo':
				if (selectedChild) {
					return this.renderChildMedicalInformation();
				} else {
					return this.renderSelectChild();
				}
			case 'select':
			default:
				return this.renderSelectChild();
		}
	}
}

Child.propTypes = {
	requireChildLastName: PropTypes.bool,
	requireChildSchool: PropTypes.bool,
	enableParentSelfBooking: PropTypes.bool,
	hasSameAsParentChild: PropTypes.bool,
	children: PropTypes.arrayOf(PropTypes.shape({
		shortName: PropTypes.string
	})),
	onSelectChild: PropTypes.func.isRequired,
	onSelectNewChild: PropTypes.func.isRequired,
	onAddChild: PropTypes.func.isRequired,
	onUpdateMedicalInformation: PropTypes.func.isRequired
};

export default withTranslation()(Child);